<template>
  <div id="app" :style="appStyle">
    <AppRecommendationBanner v-if="showAppRecommendation" @close="showAppRecommendation = false" />
    <SiteHeader />
    <div class="container">
      <router-view />
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
import AppRecommendationBanner from './components/AppRecommendationBanner.vue'

export default {
  components: {
    SiteHeader,
    SiteFooter,
    AppRecommendationBanner,
  },
  data() {
    return {
      showAppRecommendation: false
    }
  },
  computed: {
    appStyle() {
      // Adjust padding when the banner is visible
      return {
        paddingTop: this.showAppRecommendation ? '70px' : '0'
      };
    }
  },
  mounted() {
    if (isMobile()) {
      this.showAppRecommendation = true;
    }
  }
};

function isMobile() {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap');

body {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding: 0;
  background: #C4E17F; /* Light Green */
  color: #333;
}

.container {
  max-width: 1100px;
  margin: auto;
  padding: 20px;
}
</style>
